import type { FastifyInstance } from 'fastify'
import { db } from './database/firebase.js'
import { redis } from './database/redis.js'
import plannerModule from '../modules/planner/planner.module.js'
import aiModule from '../modules/ai/ai.module.js'
import collabModule from '../modules/collab/collab.module.js'
import searchModule from '../modules/search/search.module.js'
import clanModule from '../modules/clan/clan.module.js'
import { adminModule } from '../modules/admin/admin.module.js'
import { authModule } from '../modules/auth/auth.module.js'
import { notificationsModule } from '../modules/notifications/notifications.module.js'
import { usersModule } from '../modules/users/users.module.js'
import { profileModule } from '../modules/profile/profile.module.js'
import { dashboardModule } from '../modules/dashboard/dashboard.module.js'
import billingModule from '../modules/billing/billing.module.js'
import { budgetModule } from '../modules/budget/budget.module.js'
import liveModule from '../modules/live/live.module.js'
import { registerLoggingModule } from '../modules/logging/logging.module.js'
import { routeOptimizationModule } from '../modules/routeOptimization/routeOptimization.module.js'
import weatherModule from '../modules/weather/weather.module.js'
import { poiModule } from '../modules/poi/poi.module.js' // <-- NEW

export async function registerModules(app: FastifyInstance) {
  await app.register(async (instance) => {
    await plannerModule(instance, db, redis)
  }, { prefix: '/api/planner' })
  
  await app.register(async (instance) => {
    await collabModule(instance, db, redis)
  }, { prefix: '/api/collab' })

  await app.register(async (instance) => {
    await billingModule(instance, db)
  }, { prefix: '/api/billing' })
  
  await app.register(async (instance) => {
    const { GamificationController } = await import('../modules/gamification/gamification.controller.js')
    const { SeasonController } = await import('../modules/gamification/season.controller.js')
    const { gamificationRoutes } = await import('../modules/gamification/gamification.routes.js')
    const EventEmitter = (await import('node:events')).default
    
    const events = new EventEmitter()
    const controller = new GamificationController(db, redis, events)
    const seasonController = new SeasonController(db, redis)
    await gamificationRoutes(instance, controller, seasonController)
  }, { prefix: '/api/gamification' })
  
  // ✅ Backend: Sharing routes unified into CollabController (backward compat)
  await app.register(async (instance) => {
    const { CollabController } = await import('../modules/collab/collab.controller.js')
    const { sharingRoutesCompat } = await import('../modules/collab/sharing.routes.compat.js')
    
    const controller = new CollabController(redis, db)
    sharingRoutesCompat(instance, controller)
  }, { prefix: '/api/sharing' })
  
  await app.register(aiModule, { prefix: '/api/ai' })
  
  await app.register(authModule, { prefix: '/api/auth' })
  
  await app.register(searchModule, { prefix: '/api/search' })
  
  await app.register(adminModule, { prefix: '/api/admin' })
  
  await app.register(usersModule, { prefix: '/api/users' })
  
  await app.register(profileModule, { prefix: '/api/profile' })
  
  await app.register(async (instance) => {
    await dashboardModule(instance, { firestore: db, redis })
  }, { prefix: '/api/dashboard' })
  
  await app.register(notificationsModule, { prefix: '/api/notifications' })
  
  await app.register(clanModule, { prefix: '/api/clans' })
  
  await app.register(liveModule, { prefix: '/api/live' })

  await app.register(budgetModule, { prefix: '/api/budget' })

  await app.register(async (instance) => {
    await routeOptimizationModule(instance, db)
  }, { prefix: '/api/route-optimization' })

  await app.register(weatherModule, { prefix: '/api' })

  await app.register(poiModule, { prefix: '/api/pois' }) // <-- NEW POI MODULE

  await registerLoggingModule(app)

  app.log.info('✅ All modules registered')
}
